import { ArrowLeftOutlined } from '@ant-design/icons';
import { EditAppButton } from './EditAppButton';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { GoToDictionaryAppButton } from './GoToDictionaryAppButton';
import { HeaderWithButtonMenu } from '@ui/general';
import { HideAppButton } from './HideAppButton';
import { Link } from 'react-router-dom';
import { MonitorAppButton } from './MonitorAppButton';
import React from 'react';
import { RevokeAccessButton } from './RevokeAccessButton';
import { useApplicationReference } from '@hooks';
import { Button, Space } from 'antd';
export const ApplicationOverviewHeader = ({ applicationId }) => {
    const { label, name } = useApplicationReference(applicationId);
    const nameDisplay = name !== null && name !== void 0 ? name : applicationId;
    const labelDisplay = label ? ` (${label})` : '';
    const displayName = `${nameDisplay}${labelDisplay}`;
    const title = React.createElement(Space, { size: 'small' },
        React.createElement(Link, { to: FULL_ROUTES.DATA_SECURITY },
            React.createElement(Button, { className: 'back-to-overview-button', icon: React.createElement(ArrowLeftOutlined, null), type: 'link' })),
        React.createElement("div", { className: 'h2' }, displayName));
    return (React.createElement(HeaderWithButtonMenu, { title: title },
        React.createElement(RevokeAccessButton, { applicationId: applicationId }),
        React.createElement(HideAppButton, { applicationId: applicationId }),
        React.createElement(GoToDictionaryAppButton, { applicationId: applicationId }),
        React.createElement(EditAppButton, { applicationId: applicationId }),
        React.createElement(MonitorAppButton, { applicationId: applicationId })));
};
